




















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class CustomSelect extends Vue {
  @Prop()
  private value!: string;

  @Prop()
  private items!: string[];

  @Prop({ required: false, default: null })
  private label!: string;

  private get itemValue(): string {
    return this.value;
  }

  @Emit('change')
  private change(value: string): string {
    return value;
  }
}
